var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.538 13.685c-2.202-.754-3.76-1.293-3.76-3.178 0-1.725 1.343-3.018 3.491-3.018 2.202 0 3.437 1.293 3.974 2.694l1.02-.539c-.752-1.778-2.416-3.286-4.994-3.286-2.631 0-4.725 1.616-4.725 4.202 0 2.694 2.309 3.449 4.94 4.31 2.363.755 4.027 1.456 4.027 3.341 0 1.778-1.288 3.125-3.92 3.125-2.577 0-4.134-1.293-4.671-3.125l-1.02.593c.697 2.209 2.792 3.664 5.691 3.664 3.061 0 5.102-1.67 5.102-4.257 0-2.748-2.363-3.61-5.155-4.526z",
    fill: "url(#skan_svg__paint0_linear_550_4370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.794 6.573h-1.557l-7.571 7.274V6.573h-1.182v15.625h1.182v-7.705l7.786 7.705h1.557l-8.055-8.028 7.84-7.597z",
    fill: "url(#skan_svg__paint1_linear_550_4370)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.58 6.573l-6.067 15.625h1.235l1.503-3.987h7.786l1.504 3.987h1.235l-5.96-15.625H34.58zm-2.845 10.56l3.49-9.051 3.436 9.052h-6.927z",
    fill: "url(#skan_svg__paint2_linear_550_4370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.287 19.99L45.105 6.572h-1.02v15.625h1.181V8.782l9.183 13.416h1.02v-8.351h-1.182v6.142z",
    fill: "url(#skan_svg__paint3_linear_550_4370)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.416 6.52V2.531h-1.128V6.52h-3.973v1.024h3.973v4.041h1.128v-4.04h3.973V6.518h-3.973z",
    fill: "url(#skan_svg__paint4_linear_550_4370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan_svg__paint0_linear_550_4370",
    x1: 2.915,
    y1: 14.395,
    x2: 64.299,
    y2: 14.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan_svg__paint1_linear_550_4370",
    x1: 6.961,
    y1: 14.395,
    x2: 58.541,
    y2: 14.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan_svg__paint2_linear_550_4370",
    x1: 5.128,
    y1: 14.395,
    x2: 59.053,
    y2: 14.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan_svg__paint3_linear_550_4370",
    x1: 3.787,
    y1: 14.395,
    x2: 59.234,
    y2: 14.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan_svg__paint4_linear_550_4370",
    x1: 3.967,
    y1: 7.035,
    x2: 59.331,
    y2: 7.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })))));
}
export default SvgSkan;